export default "__VITE_ASSET__CWSu33Bp__"